export enum ChainFeature {
  STAKING = "staking",
  GOV = "gov",
}
